import useErrorHandler from '@beeldit/core/errors/useErrorHandler';
import get from '@beeldit/core/services/get';
import { useContext } from 'react';
import { ProjectContext } from '../contexts/ProjectContext';

function useGet() {    const {setElement, setShowModal} = useContext(ProjectContext);
    const errorHandler = useErrorHandler();
    
    return (id: any, onSuccess: any = (data: any) => {return data}) => {
      get('projects', id)
        .then((response: any) => {
          let data = response.data;
          data = onSuccess(response.data);
          setElement(data);
          setShowModal(true);
        })
        .catch((error: any) => {
          errorHandler(error)
        });
      
      
    }
  }

  
  export default useGet;